(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
    .factory('VisualizacaoService', VisualizacaoService);

  function VisualizacaoService($http, ngsalConfig) {

    var service = {
      getAbasVisualizacao: getAbasVisualizacao,
      getDetalhamentoAnalitico: getDetalhamentoAnalitico
    };

    return service;

    function getAbasVisualizacao(pessDk, relMensalDk) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/"+pessDk+"/relatorio/"+relMensalDk+"/abas").then(function (response) {
          return response.data;
      });

      return promise;
    }

    function getDetalhamentoAnalitico(pessDk, relDk, linhaDK) {

      var promise = $http.get("/mgp-corregedoria/api/" + ngsalConfig.apiVersion +
        "/promotor/" + pessDk + "/relatorio/" + relDk + "/analitico/" + linhaDK)
      .then(function (response) {
          return response.data;
      });

      return promise;
    }
  }

})();
